import { render, staticRenderFns } from "./deleteApplyRoomDiscountRecord.vue?vue&type=template&id=5bd4b6f5&scoped=true"
import script from "./deleteApplyRoomDiscountRecord.vue?vue&type=script&lang=js"
export * from "./deleteApplyRoomDiscountRecord.vue?vue&type=script&lang=js"
import style0 from "./deleteApplyRoomDiscountRecord.vue?vue&type=style&index=0&id=5bd4b6f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4b6f5",
  null
  
)

export default component.exports